import { render, staticRenderFns } from "./relationselect.vue?vue&type=template&id=62081eba&scoped=true&"
import script from "./relationselect.vue?vue&type=script&lang=js&"
export * from "./relationselect.vue?vue&type=script&lang=js&"
import style0 from "./relationselect.vue?vue&type=style&index=0&id=62081eba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62081eba",
  null
  
)

export default component.exports